import { Component, ElementRef, EventEmitter, Output, ViewChild } from '@angular/core';
import { ProductCategoryService, ProductCategory } from 'src/app/core/product-category.service';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';

@Component({
  selector: 'app-product-category-data',
  templateUrl: './product-category-data.component.html',
  styleUrls: ['./product-category-data.component.scss'],
})
export class ProductCategoryDataComponent {
  @ViewChild('product_category_load_more') load_more_layout?: ElementRef;
  @Output() refresh: EventEmitter<void> = new EventEmitter<void>();
  is_list_running: boolean = true;
  is_load_more_running: boolean = true;
  product_categories?: ProductCategory[];
  cursor: string | null = null;
  total?: number;

  constructor(private product_category_service: ProductCategoryService, private error_service: ErrorService) {}

  ngOnInit(): void {
    this.product_categories = [];
    this.cursor = null;
    this.total = undefined;
    this.listProductCategories();
  }

  onRefresh(): void {
    this.product_categories = [];
    this.total = undefined;
    this.cursor = null;
    this.listProductCategories();
  }

  onScrollEnd(): void {
    if (this.cursor && !this.is_load_more_running) this.onLoadMoreClick();
  }

  onLoadMoreClick(): void {
    this.listProductCategories(true);
  }

  listProductCategories(is_load_more_running?: boolean): void {
    this.is_list_running = !is_load_more_running;
    this.is_load_more_running = is_load_more_running || false;

    const list_product_category_params = {
      cursor: this.cursor,
    };

    this.product_category_service.listProductCategories(list_product_category_params).subscribe({
      next: response => {
        // AWS Amplify API.get response body is in response.data
        const categories = response.data.data;
        this.product_categories = (this.product_categories ? this.product_categories : []).concat(categories);
        this.cursor = response.data.cursor;
        if (list_product_category_params.cursor == undefined) {
          this.total = response.data.total.value;
        }
        this.is_list_running = false;
        this.is_load_more_running = false;
      },
      error: error => {
        const processed_error: SplittypayError = this.error_service.preProcessApiError(error);
        this.error_service.processApiError(processed_error.code, processed_error.message);
        this.is_list_running = false;
        this.is_load_more_running = false;
      },
    });
  }
}
